module.exports = __webpack_public_path__ + "static/img/stay-option-icon-outdoorpool.80d4b35a.svg";